import { Base, Component, Watch } from '@/vue-property-decorator'
import { Icon, Layout, Row } from '@/plugins/ant-design-vue/tsx-support'
import { RouteName } from '@/router/config'
import { createPngSprite } from '@/utils/business-utils/assets'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import { useMusicStore } from '@/layouts/components/music/store'
import HallCustomization from '@/controller/hallCustomization'
import LogoBox from '../logo-box'
import Modal from '@/controller/Modal'
import Skin from '@/controller/Skin'
import style from './style.module.scss'

interface State {
  musicPlaying: boolean
}

interface ScopedSlots {
  holidayTheme?: void
}

@Component<H5HeaderLayout>({
  name: 'H5HeaderLayout'
})
export default class H5HeaderLayout extends Base<
  State,
  unknown,
  unknown,
  ScopedSlots
> {
  private mainStore = useMainStore()

  private musicStore = useMusicStore()

  state: State = {
    musicPlaying: false
  }

  @Watch('musicStore.musicPlay')
  protected onMusicPlay() {
    const musicPlay = this.musicStore.musicPlay
    this.state.musicPlaying = musicPlay
  }

  render() {
    const { t } = useI18n()
    const { hasLogined, showMusic, language } = this.mainStore
    const { customizeTopIconMap } =
      HallCustomization.useHomeCustomizeIcon('top')
    const { isHolidayThemeVisible } = Skin

    // 经典版h5页头带节日logo
    return (
      <Layout.Tsx
        class={{
          [style.h5Header]: true,
          [style['header-vi_VN']]: language === 'vi_VN',
          [style.noLoginedMobileMain]: !hasLogined
        }}
      >
        <div
          class={[style.logo, isHolidayThemeVisible ? 'h5HeaderLogo' : '']}
          key="logo"
        >
          <LogoBox />
        </div>
        {this.$scopedSlots.holidayTheme?.()}
        <Row.Tsx
          class={style.right}
          type={'flex'}
          key="right"
          justify={'space-between'}
          align={'middle'}
        >
          <div
            class={[style.navWrap, style.search]}
            onClick={() => {
              this.$root.$emit('leaveHomePage')
              this.$router.push({
                name: RouteName.GAME_SEARCH,
                query: {
                  gameCategoryId: this.$route.query?.gameCategoryId || '0'
                }
              })
            }}
          >
            <Icon.Tsx
              component={{
                functional: true,
                render: () => {
                  const icon =
                    customizeTopIconMap.get('searchIcon') ||
                    createPngSprite('sprite_main_icon_dt_1ss')
                  const iconWidth = typeof icon === 'string' ? 80 : icon?.width
                  const scale = 54 / iconWidth
                  if (typeof icon === 'string') {
                    return <my-img useSkeleton src={icon} width={54} />
                  }
                  return <icon-sprite useSkeleton sprite={icon} scale={scale} />
                }
              }}
            />
            <div>{t('lobby.game.search')}</div>
          </div>
          {showMusic && (
            <div
              class={[style.navWrap, style.musicIcon]}
              onClick={() => Modal.open('musicModal')}
            >
              <Icon.Tsx
                class={{ [style.musicRotate]: this.state.musicPlaying }}
                component={{
                  functional: true,
                  render: () => {
                    const icon =
                      customizeTopIconMap.get('musicIcon') ||
                      createPngSprite('sprite_main_icon_dt_1yy')
                    const iconWidth =
                      typeof icon === 'string' ? 80 : icon?.width
                    const scale = 54 / iconWidth
                    if (typeof icon === 'string') {
                      return <my-img useSkeleton src={icon} width={54} />
                    }

                    return (
                      <icon-sprite useSkeleton sprite={icon} scale={scale} />
                    )
                  }
                }}
              />
              <div>{t('lobby.header.menus.music')}</div>
            </div>
          )}
        </Row.Tsx>
      </Layout.Tsx>
    )
  }
}
